
import * as constants from '../Constatnts'
import axios from 'axios';



export function getPackages(registrationID, storeID, from, size, option, 
    packageName,transactionNo, searchText) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      let apiUrl = "/transaction/packages";
      let queryParams = [];

      // ✅ Required parameter
      if (storeID !== null && storeID !== undefined && storeID !== "") {
        queryParams.push(`storeID=${encodeURIComponent(storeID)}`);
      }

      // ✅ Pagination parameters
      if (from !== null && from !== undefined) {
        queryParams.push(`from=${from}`);
      }

      if (size !== null && size !== undefined) {
        queryParams.push(`size=${size}`);
      }

      // ✅ Option (Package Status)
      if (option && option.trim() !== "") {
        queryParams.push(`option=${encodeURIComponent(option)}`);
      }

      // ✅ Package Name
      if (packageName && packageName.trim() !== "") {
        queryParams.push(`packageName=${encodeURIComponent(packageName)}`);
      }

      // ✅ Transaction No
      if (transactionNo && transactionNo.trim() !== "") {
        queryParams.push(`transactionNo=${encodeURIComponent(transactionNo)}`);
      }

      // ✅ Search Text (searches across CustomerName, CustomerEmailID, CustomerPhoneNo, CustomerCode)
      if (searchText && searchText.trim() !== "") {
        queryParams.push(`searchText=${encodeURIComponent(searchText)}`);
      }

      // Build URL with query parameters
      if (queryParams.length > 0) {
        apiUrl += "?" + queryParams.join("&");
      }

      const response = await axios.get(constants.API_URL + apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

        return { totalItemsCount:response.data.totalCount, searchResult:response.data.searchResult }
    } catch (err) {
      console.error("Error fetching packages:", err);
      throw err;
    }
  };
}


export function getPackageDetails(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/transaction/package/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.pakage;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function  updatePackage(objPackage, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.put(
        `${constants.API_URL}/transaction/updatePackage/${key}`,
        objPackage,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
      return true;
      }
      else{return false}
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}




export function getCustomerPackages(customerID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
       const response = await axios.get(
        `${constants.API_URL}/crm/customers/customerpackages/${customerID}`,
        {
          params: {
            option: "all"
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("package response",response);
       return { totalItemsCount:response.data.totalItemsCount, searchResult: response.data.searchResult }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
// export function getCustomerPackages(customerID) {
//   let searchParameters = {
//     "from": 0,
//     "size": 10,
//     "track_total_hits": true,
//     "query": {
//       "bool": {
//         "must": [
//           { "match": { "CustomerID": customerID } }
//         ]
//       }
//     },
//     "sort": [
//       { "PackageStartDate": { "order": "desc" } }
//     ]
//   }

//   // console.log(JSON.stringify(searchParameters));
//   return (dispatch) => {
//     let addMessage = firebase.functions().httpsCallable('getPackages');

//     return addMessage({ text: searchParameters }).then(function (result) {
//       const packages = []
//       let sanitizedMessage = result.data.text;
//       sanitizedMessage.hits.hits.map((data, index) => {
//         packages.push({ key: data._id, ...data._source })
//       })
//       return { totalItemsCount: sanitizedMessage.hits.total.value, searchResult: packages }
//     });
//   }
// }